import { NavLink, NavLinkProps } from 'react-router-dom'
import { Container } from '@/components/ui/template/Container'
import { useCookieConsent } from '@/hooks/useCookieConsent'
import { CopyContainer } from './CopyContainer'
import { truncateAddress } from '@/utils/truncate-address'
import { usePepperContractAddress } from '@/hooks/pepper-contract/usePepperContract'
import { testIdFactory } from '@/utils/test-id-factory.ts'

const FOOTER_LINKS = [
	{
		label: 'Terms and Conditions',
		to: '/terms-and-conditions',
		testId: testIdFactory.footerTermsAndConditionsLink()
	},
	{ label: 'Privacy Policy', to: '/privacy-policy', testId: testIdFactory.footerPrivacyPolicyLink() },
	{ label: 'Cookie Policy', to: '/cookie-policy', testId: testIdFactory.footerCookiePolicyLink() }
] satisfies Array<Partial<NavLinkProps> & { label: string; testId: string }>

const Footer = () => {
	const { showPreferences } = useCookieConsent()
	const pepperAddress = usePepperContractAddress()

	return (
		<Container as="footer" className="bg-neutral">
			<Container.Content className="flex flex-col-reverse gap-4 items-center py-10 px-16 md:py-5 text-[1.25rem] text-neutral-100 md:justify-between leading-none">
				<div className="flex gap-6">
					{FOOTER_LINKS.map((link, idx) => (
						<NavLink
							key={idx}
							to={link.to}
							className={({ isActive }) => (isActive ? 'text-danger font-bold' : '')}
							data-testid={link.testId}
						>
							{link.label}
						</NavLink>
					))}
					<button
						className="hover:cursor-pointer"
						onClick={showPreferences}
						data-testid={testIdFactory.footerManagePreferencesLink()}
					>
						Manage Preferences
					</button>
				</div>
				<div className="flex justify-center items-center gap-2">
					<span className="text-xl">Contract:</span>
					<CopyContainer
						className="gap-2"
						copyable={pepperAddress}
						dataTestId={testIdFactory.footerCopyAddressContainer()}
					>
						<img
							src="https://assets-staking.chiliz.com/images/assets/pepper.webp"
							alt="logo"
							loading="lazy"
							className="size-[24px] aspect-square"
						/>
						<span className="text-neutral-100 leading-none text-[1.5rem]">
							{truncateAddress(pepperAddress)}
						</span>
					</CopyContainer>
				</div>
				<p>© 2024 PEPPER COIN. All rights reserved.</p>
			</Container.Content>
		</Container>
	)
}

export default Footer
